import { render, staticRenderFns } from "./acts-page.vue?vue&type=template&id=a82a85a2"
import script from "./acts-page.vue?vue&type=script&lang=js"
export * from "./acts-page.vue?vue&type=script&lang=js"
import style0 from "./acts-page.vue?vue&type=style&index=0&id=a82a85a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports